import { parseDdMmYyyyToIso } from './portalDateFormat'

export const TEXTO_SIN_FECHA_INFORME = 'Sin fecha especificada'

/** Normaliza entero nullable desde la API. */
function readNullableInt(value) {
  if (value == null || value === '') return null
  const n = Number(value)
  return Number.isFinite(n) ? n : null
}

function esTipoInformeLaboratorio(value) {
  return String(value ?? '').trim().toUpperCase() === 'LR'
}

function toInformeDisplayDate(value) {
  if (value == null || value === '') return null
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value
  }

  const s = String(value).trim()
  const isoFromDdMm = parseDdMmYyyyToIso(s.split(/\s+/)[0])
  if (isoFromDdMm) {
    const [y, mo, d] = isoFromDdMm.split('-').map(Number)
    return new Date(y, mo - 1, d)
  }

  const d = new Date(s)
  return Number.isNaN(d.getTime()) ? null : d
}

/** Fecha de informe para la tabla (API ISO, Date o dd/MM/yyyy), sin hora. */
export function formatInformeFechaTabla(value) {
  const d = toInformeDisplayDate(value)
  if (!d) return TEXTO_SIN_FECHA_INFORME
  return d.toLocaleDateString('es-AR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
}

/** Fecha en móvil: mes completo, sin hora. */
export function formatInformeFechaMobile(value) {
  const d = toInformeDisplayDate(value)
  if (!d) return TEXTO_SIN_FECHA_INFORME
  return d.toLocaleDateString('es-AR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
}

export function mapInformeRow(raw, index) {
  const servNombre = raw.servNombre ?? ''
  const tipoInforme = raw.tipoInforme ?? ''
  const informe = String(servNombre || tipoInforme).trim() || '—'
  const fec = raw.mpFecha ?? null
  const infoId = readNullableInt(raw.infoId)
  const infoLabId = readNullableInt(raw.infoLabId)
  const esLaboratorio = esTipoInformeLaboratorio(tipoInforme) || (infoLabId != null && infoLabId > 0)
  const mpId = readNullableInt(raw.mpId)
  const accessionNumber = raw.accessionNumber
  const accStr =
    accessionNumber != null ? String(accessionNumber).trim() : ''
  const id = `${infoId ?? 'n'}-${mpId ?? 'n'}-${index}`
  return {
    id,
    informe,
    fechaDisplay: formatInformeFechaTabla(fec),
    fechaSort: fec,
    infoId,
    infoLabId,
    esLaboratorio,
    mpId,
    accessionNumber: accStr,
  }
}

/** Estudio: requiere accession y mpId (puede coexistir con informe PDF). */
export function informeRowPuedeVerEstudio(row) {
  if (!row) return false
  const acc = String(row.accessionNumber ?? '').trim()
  if (!acc) return false
  const mp = row.mpId
  return mp != null && mp > 0
}

export function informeRowPuedeVerInforme(row) {
  const infoId = row?.infoId
  return infoId != null && infoId > 0
}
